import { useCallback, useEffect } from 'react';
import { Platform } from 'react-native';
import env from '@/src/core/config/env';
import { logger } from '@/src/core/utils';
import { useSubscription } from '@/src/context/SubscriptionContext';

// Conditionally import to avoid web crashes
let useRNInterstitialAd: any;
let TestIds: any;
if (Platform.OS !== 'web') {
  try {
    const ads = require('react-native-google-mobile-ads');
    useRNInterstitialAd = ads.useInterstitialAd;
    TestIds = ads.TestIds;
  } catch {
    // Module not available (e.g., Expo Go)
  }
}

const noopResult = { showAd: () => {}, isAdReady: false };

export const useInterstitialAd = () => {
  const { isPro } = useSubscription();

  if (Platform.OS === 'web' || !useRNInterstitialAd || isPro) {
    return noopResult;
  }

  return useInterstitialAdMobile();
};

function useInterstitialAdMobile() {
  const adUnitId =
    Platform.OS === 'ios'
      ? env.admobInterstitialIdIos || TestIds.INTERSTITIAL
      : env.admobInterstitialIdAndroid || TestIds.INTERSTITIAL;

  const { isLoaded, isClosed, load, show, error } = useRNInterstitialAd(adUnitId);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (isClosed) {
      load();
    }
  }, [isClosed, load]);

  useEffect(() => {
    if (error) {
      logger.warn('AdMob', 'Interstitial failed to load', { error: String(error) });
    }
  }, [error]);

  const showAd = useCallback(() => {
    if (isLoaded) {
      show();
      logger.debug('AdMob', 'Interstitial shown');
    }
  }, [isLoaded, show]);

  return { showAd, isAdReady: isLoaded };
}
